import {
  DeliveryStatusBadge,
  StatusBadge,
} from "../../components/status-badge";
import { formatDateTime } from "../../lib/format";
import type { PipelineRunDetail } from "../../lib/api";

function Value({ label, value }: { label: string; value: string | null }) {
  return (
    <div>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="break-all text-sm font-medium">{value ?? "нет данных"}</p>
    </div>
  );
}

export function RunSummary({ run }: { run: PipelineRunDetail }) {
  return (
    <>
      <section className="panel mb-4 border-l-4 border-l-primary p-4">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Почему агент ответил или не ответил
        </p>
        <h2 className="mt-2 text-lg font-semibold">
          {run.diagnosticConclusion.title}
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {run.diagnosticConclusion.description}
        </p>
        {run.diagnosticConclusion.lastSuccessfulStage ? (
          <p className="mt-2 text-sm">
            Последний успешный этап:{" "}
            {run.diagnosticConclusion.lastSuccessfulStage.title}
            {` · ${formatDateTime(run.diagnosticConclusion.lastSuccessfulStage.occurredAt)}`}
          </p>
        ) : null}
        {run.diagnosticConclusion.problemStage ? (
          <p className="mt-1 text-sm text-danger">
            Проблемный этап: {run.diagnosticConclusion.problemStage.title}
            {` · ${formatDateTime(run.diagnosticConclusion.problemStage.occurredAt)}`}
          </p>
        ) : null}
        <p className="mt-2 text-xs text-muted-foreground">
          {run.diagnosticConclusion.code}
        </p>
      </section>

      <section className="panel mb-4 p-4">
        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge status={run.status} />
          {run.resultDisplay && <span className="rounded-md border px-2 py-1 text-xs font-medium">{run.resultDisplay.label}</span>}
          <DeliveryStatusBadge
            status={run.delivery.status}
            label={run.delivery.display.label}
          />
          <span className="text-sm text-muted-foreground">
            {formatDateTime(run.createdAt)}
          </span>
        </div>
        <div className="mt-3 grid gap-3 rounded-md bg-muted p-3 text-sm sm:grid-cols-2">
          <div>
            <p className="font-medium">{run.processingDisplay.label}</p>
            <p className="text-muted-foreground">
              {run.processingDisplay.description}
            </p>
          </div>
          <div>
            <p className="font-medium">{run.delivery.display.label}</p>
            <p className="text-muted-foreground">
              {run.delivery.display.description}
            </p>
          </div>
        </div>
        <div className="mt-4 grid gap-3 sm:grid-cols-3 lg:grid-cols-4">
          <Value label="Имя" value={run.sender.name} />
          <Value label="Телефон" value={run.sender.phone} />
          <Value label="Username" value={run.sender.username} />
          <Value label="Chat ID" value={run.sender.chatId} />
          <Value label="amoCRM contact ID" value={run.amo.contactId} />
          <Value label="amoCRM lead ID" value={run.amo.leadId} />
          <Value label="amoCRM pipeline ID" value={run.amo.pipelineId} />
          <Value
            label="Wazzup outgoing ID"
            value={run.delivery.wazzupMessageId}
          />
        </div>
      </section>
    </>
  );
}
